module.exports = __webpack_public_path__ + "6eb2a1c0bc378d8c21d45571095940d9.png";